<template>
  <div>
    <template v-if="soldDiffDataLocal">
      <v-popover
        :auto-hide="true"
      >
        <div>
          <span
            :class="{'badge pointer': true,
        'badge-danger': soldDiffDataLocal.last_sold_rate > soldDiffDataLocal.preset_sold_rate,
        'badge-success': soldDiffDataLocal.last_sold_rate <= soldDiffDataLocal.preset_sold_rate
      }">{{ soldDiffDataLocal.last_sold_rate }}</span>
          |
          <span
            :class="{'badge pointer': true,
        'badge-danger': soldDiffDataLocal.last_sold_rate > soldDiffDataLocal.preset_sold_rate,
        'badge-success': soldDiffDataLocal.last_sold_rate <= soldDiffDataLocal.preset_sold_rate
      }">{{ soldDiffDataLocal.preset_sold_rate }}</span>
        </div>
        <template slot="popover">
          <p>продажи за {{ soldDiffDataLocal.days }} дней</p>
          <p>{{ soldDiffDataLocal.total_qty }} / <strong>{{ soldDiffDataLocal.last_sold_rate }}</strong> в день</p>
          <hr class="m-1">
          <p>продажи с {{ printDate(soldDiffDataLocal.start_date, 'DD.MM.YYYY') }}</p>
          {{ soldDiffDataLocal.present_sold }} / <strong>{{ soldDiffDataLocal.preset_sold_rate }}</strong> в день
        </template>
      </v-popover>
    </template>
    <template v-else>
      loading...
    </template>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['soldData', 'drug'],
  data() {
    return {
      soldDiffDataLocal: null,
    }
  },
  watch: {
    'soldData': {
      handler: function (val, oldVal) {
        if (this.soldData) this.soldDiffDataLocal = {...this.soldData};
      },
    },
  },
  created() {
    if (this.soldData) {
      this.soldDiffDataLocal = {...this.soldData};
      return;
    }
    if (this.drug?.id) this.getSoldDiffData();
  },
  methods: {
    async getSoldDiffData() {
      const {data} = await api.post('/analytics/drugs/sales', {
        ids: [this.drug.id]
      });
      if (data.success) {
        const listData = data.records.reduce((acc, r) => {
          const lsr = Math.round(r.total_qty / data.days * 10) / 10;
          const psr = Math.round((data.presentSold[r.drug_id]?.total_qty ?? 0) / data.present_days_diff * 10) / 10
          acc[r.drug_id] = {
            ...r,
            present_sold: data.presentSold[r.drug_id]?.total_qty ?? 0,
            last_sold_rate: lsr,
            preset_sold_rate: psr,
            sold_diff: lsr - psr,
            days: data.days,
            history_date: data.history_date,
            start_date: data.start_date
          };
          return acc;
        }, {});
        this.soldDiffDataLocal = listData[this.drug.id];
      }
    },
  }
}

</script>
